import { DownloadOutlined } from "@ant-design/icons";
import { faDownload, faToggleOn, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, Space } from "antd";
import { exportLayout } from "../../utils/export";

const MoreActionsMenu = (item, { onActivate, onDelete }) => {
  return (
    <Menu>
      {/* Activate Layout (if not active) */}
      {!item.isActive && (
        <Menu.Item key="activate" onClick={() => onActivate(item)}>
          <Space>
            <FontAwesomeIcon icon={faToggleOn} />
            Activate Layout
          </Space>
        </Menu.Item>
      )}

      {/* Export Submenu */}
      <Menu.SubMenu
        key="export"
        title={
          <Space>
            <FontAwesomeIcon className="layoutActions" icon={faDownload} />
            Export
          </Space>
        }
      >
        <Menu.Item key="export-stack360" onClick={() => exportLayout(item, "stack360")}>
          <Space>
            <DownloadOutlined />
            Export as Stack360 (Compressed)
          </Space>
        </Menu.Item>
        <Menu.Item key="export-json" onClick={() => exportLayout(item, "json")}>
          <Space>
            <DownloadOutlined />
            Export as JSON (Legacy)
          </Space>
        </Menu.Item>
      </Menu.SubMenu>

      {/* Delete Layout */}
      <Menu.Item key="delete" onClick={() => onDelete(item)}>
        <Space>
          <FontAwesomeIcon className="layoutActions" icon={faTrashCan} />
          Delete Layout
        </Space>
      </Menu.Item>
    </Menu>
  );
};

export default MoreActionsMenu;
